module.exports = ["ai","2017","2018","cryptocurr","blockchain","elect","fake","selfdriv","ico","harass","gdpr","ransomwar","specul","ethereum","crypto","audit","misinform","ledger","disinform","machinelearn","blockchainbas","electromagnet","weed","retrain","sanit","freeway","rgb","vortex","btc","immut","discriminatori","cv","tomographi","machin_learn","artifici_intellig","fake_news","blockchain_technolog","magnet_field","presidenti_elect","ai_system","intellig_ai","smart_contract","learn_model","distribut_ledger","learn_system","medic_imag"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/words_total.json
// module id = rxqw
// module chunks = 1